<template>
    <!--   营销管理－优惠券管理-发放优惠券 -->
    <div>
        <content-view>
        <div slot="header">
            <a-form :form="form" layout="inline">
                <a-form-item label="发放时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['offerTime']"
                    />
                </a-form-item>
                <a-form-item label="导入时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['importTime']"
                    />
                </a-form-item>
                <a-form-item label="操作人">
                    <a-input placeholder="请输入" v-decorator="['operator']"></a-input>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>

        <div>
            <a-card
            :bordered="false"
            :tabList="tabListNoTitle"
            :activeTabKey="noTitleKey"
            @tabChange="key => onTabChange(key)"
            >
                <div slot="tabBarExtraContent">
                    <a-button type="primary" @click="openSend('batch')" v-if="getBtnByAuth('batchSendCoupon')">批量发放</a-button>
                    <a-button type="primary" @click="openSend('single')" v-if="getBtnByAuth('singleSendCoupon')">单独发放</a-button>
                </div>
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="noTitleKey == 1 ? columns : columnsAlone"
                    :scroll="{ x: 800 }" 
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="(record,index) => index"
                >
                    <template slot="empty" scope="empty">{{empty || '--'}}</template>
                    <div slot="action" slot-scope="a,row">
                        <a class="text-primary" @click="downLoadImportExcel(row.batchOfferId)">下载导入表格</a>
                        <a-divider type="vertical"/>
                        <a class="text-primary" @click="openFail(row.batchOfferId)">查看失败数据</a>
                    </div>
                </a-table>
            </a-card>
        </div>
        <!--  发放优惠券弹框 -->
        <a-modal
            centered
            :title="type == 'single' ? '单独发放' : '批量发放'"
            :visible="visible"
            :confirmLoading="loading"
            @cancel="closeModal"
            @ok="onSubmit"
            >
            <a-form :form="formModal">
                <a-form-item :required="type == 'batch'" v-bind="formItemLayout" label="上传导入表格" v-show="type == 'batch'">
                    <a-row>
                        <a-col span="12">
                            <a-upload
                                name="file"
                                accept=".xlsx"
                                :multiple="false"
                                :file-list="fileList"
                                :remove="remove"
                                :beforeUpload="beforeUpload"
                                :customRequest="customRequest"
                                @change="handleChange"
                            >
                                <a-button><a-icon type="upload" />上传文件</a-button>
                            </a-upload>
                        </a-col>
                        <a-col span="9">
                            <a class="text-primary" @click="batchOfferTemplateUrl">下载表格模板</a>
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item required v-bind="formItemLayout" label="优惠券名称">
                    <span class="mr8" v-if="couponListSelected.length > 0">{{couponListSelected[0].name}}</span>
                    <a-button type="primary" @click="toSelectGoods('coupon')">选择优惠券</a-button>
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="会员手机号" v-show="type == 'single'">
                    <a-input
                        placeholder="请输入"
                        v-decorator="['mobile',{rules: [{ required: type == 'single', message: '会员手机号!'}]}]"
                    />
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="发放优惠券数量">
                    <a-input-number
                        style="width: 100%"
                        placeholder="请输入(10以内)"
                        :min="1"
                        :max="10"
                        v-decorator="['offerNum', {rules: [{required: true, message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入正整数'}]}]" />
                </a-form-item>
                <!-- <remark :labelSpan="5" :wrapperSpan="19" operateCode="UpdatePoints" /> -->
                <a-form-item v-bind="formItemLayout" label="原因">
                    <a-radio-group v-decorator="['remarkCategoryCode',{rules: [{required:true}]}]">
                        <a-radio value="Compensate">客诉</a-radio>
                        <a-radio value="PublicRelation">公关</a-radio>
                        <a-radio value="Activity">活动</a-radio>
                        <a-radio value="EmployeeBenefits">员工福利</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="备注">
                    <a-textarea :maxLength="50" v-decorator="['remark',{rules: [{required:true,message:'请输入备注(50字以内)',max:50}]}]" placeholder="请输入" :rows="2" />
                    <span class="text-disabled">{{formModal.getFieldValue('remark') ? String(formModal.getFieldValue('remark')).length : 0}}/50</span>
                </a-form-item>
            </a-form>
        </a-modal>
        <!-- 查看失败数据 -->
        <a-modal
            centered
            title="查看失败数据"
            :visible="visibleFail"
            @cancel="visibleFail = false"
            @ok="visibleFail = true"
            >
                <a-table
                    :bordered="true"
                    :dataSource="dataSourceFail"
                    :columns="columnsFail"
                    :pagination="paginationFail"
                    @change="changePageFail"
                    :rowKey="(record,index) => index"
                >
                    <span slot="index" slot-scope="a,b,index">{{index+1}}</span>
                </a-table>
        </a-modal>
        <ticket-picker tableType="radio" goodType="coupon" ref="ticketPicker" :couponList="newCouponsList" @confirmSelectTicket='confirmSelect'></ticket-picker>
        <!-- <ticket-picker tableType="radio" goodType="coupon" ref="ticketPicker" @confirmSelectTicket="confirmSelect"></ticket-picker> -->
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import ticketPicker from "@/components/modules/platform/tickets-picker.component"
    import imagesUploader from '@/components/common/images-uploader.component';

    const tabListNoTitle = [
        {
            key: '1', 
            tab: '批量发放'
        },
        {
            key: '2',
            tab: '单独发放'
        },
    ]
    const columns = [
        {
            title: "导入表格名称",
            dataIndex: "importExcelName"
        },
        {
            title: "导入时间",
            dataIndex: "importTime"
        },
        {
            title: "操作人",
            dataIndex: "operator",
        },
        {
            title: "原因",
            dataIndex: "remarkCategoryName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "备注",
            dataIndex: "remark",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const columnsAlone = [
        {
            title: "会员手机号",
            dataIndex: "mobile",
        },
        {
            title: "优惠券id",
            dataIndex: "couponId"
        },
        {
            title: "展示名称",
            dataIndex: "couponName"
        },
        {
            title: "内部标识",
            dataIndex: "couponInnerName"
        },
        {
            title: "发放状态",
            dataIndex: "offerState"
        },
        {
            title: "发放时间",
            dataIndex: "offerTime"
        },
        {
            title: "操作人",
            dataIndex: "operator",
        },
        {
            title: "原因",
            dataIndex: "remarkCategoryName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "备注",
            dataIndex: "remark",
            scopedSlots: { customRender: "empty" }
        }
    ];
    export default {
        name: "couponSend",
        components: {ticketPicker,imagesUploader},
        props: {},
        data() {
            return {
                formItemLayout: {
                    labelCol: {
                        span: 7
                    },
                    wrapperCol: {
                        span: 16
                    }
                },
                dataSource: [],
                columns,
                columnsAlone,
                dataSourceFail: [],
                columnsFail: [{
                    title: "序号",
                    dataIndex: "index",
                    scopedSlots: {customRender: "index"}
                },
                {
                    title: "会员手机号",
                    dataIndex: "mobile"
                },
                {
                    title: "失败原因",
                    dataIndex: "reason",
                }],
                tabListNoTitle: tabListNoTitle,
                noTitleKey: '1',
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                paginationFail: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                couponListSelected: [],
                visible: false,
                visibleConfirmUpload: false,
                type: '',
                loading: false,
                visibleFail: false,
                formData: undefined,
                fileList: [],
                newCouponsList: []
            };
        },
        watch: {},
        methods: {
            toSelectGoods() {
                this.$refs.ticketPicker.selectedTicketsRowKeys = this.couponListSelected.map(el => el.id);
                // this.$refs.ticketPicker.selectedRowData(this.couponListSelected);
                this.$refs.ticketPicker.visible = true;
            },
            confirmSelect(list) {
                this.couponListSelected = list;
                this.$refs.ticketPicker.closeModal();
            },
            handleReset() {
                this.pagination.current = 1;
                this.form.resetFields();
                this.getList()
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            changePageFail(page) {
                this.paginationFail.pageSize = page.pageSize;
                this.paginationFail.current = page.current;
                this.getListFail();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey
                this.pagination.current = 1;
                this.getList()
            },
            openSend(type) {
                this.type = type;
                this.visible = true;
            },
            closeModal() {
                this.visible = false;
                this.fileList = [];
                this.couponListSelected = [];
                this.formModal.resetFields();
            },
            openFail(id) {
                this.visibleFail = true;
                this.getListFail(id);
            },
            /**
             * @handleChange 导入文件选择
             */
            handleChange(info) {
                //上传成功
                if (info.file.status === 'done') {
                    this.$message.success(`${info.file.name} 上传成功`);
                } else if (info.file.status === 'error') {
                    this.$message.error(`${info.file.name} 上传失败`);
                }
            },
            
            /**
             * @beforeUpload 上传前拦截
             */
            beforeUpload(file, fileList) {
                // 可用于校验文件
                console.log(123);
                return true;
            },
            /**
             * @customRequest 自定义上传
             */
            customRequest({ onSuccess, onError, onProgress, file }) {
                this.formData = new FormData();
                this.formData.append('file', file);
                this.fileList = [file];
                onSuccess();
            },
            /**
             * @uploadVerification 验证上传文件
             */
            uploadVerification() {
                this.visibleConfirmUpload = true;
            },
            remove(file) {
                this.fileList = []
            },

            batchOfferTemplateUrl() {
                this.$api.changeCode.batchOfferTemplateUrl().then( res => {
                    window.open(res);
                })
            },
            downLoadImportExcel(batchOfferId) {
                this.$api.changeCode.downLoadImportExcel({
                    params: {
                        batchOfferId: batchOfferId
                    }
                }).then(res => {
                    this.$message.success('操作成功！');
                    this.downloadFile(res);
                }).catch(err => {
                    
                });
            },
            downloadFile(exportUrl) {
                let a = document.createElement('a');
                a.href = exportUrl;
                a.click();
            },
            //获取失败列表
            getListFail(id) {
                this.$api.changeCode.queryFailureRecord({
                    body: {
                        batchOfferId: id,
                        pageNum: this.paginationFail.current,
                        pageSize: this.paginationFail.pageSize
                    }
                }).then(res => {
                    this.dataSourceFail = res.list;
                    this.paginationFail.total = res.total;
                });
            },
            //获取列表
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const offerTime = values['offerTime'] ? values['offerTime'] : [];
                    values.offerTimeStart = offerTime.length > 0 ? offerTime[0].format('YYYY-MM-DD') : undefined;
                    values.offerTimeEnd = offerTime.length > 0 ? offerTime[1].format('YYYY-MM-DD') : undefined;
                    const importTime = values['importTime'] ? values['importTime'] : [];
                    values.importTimeStart = importTime.length > 0 ? importTime[0].format('YYYY-MM-DD') : undefined;
                    values.importTimeEnd = importTime.length > 0 ? importTime[1].format('YYYY-MM-DD') : undefined;
                    delete values.offerTime;
                    delete values.importTime;
                    
                    this.$api.changeCode[this.noTitleKey == '1' ? 'queryBatchOfferByPage' : 'querySingleOfferByPage']({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    }).then(res => {
                        this.dataSource = res.list;
                        this.pagination.total = res.total;
                    });
                });
            },
            onSubmit() {

                this.formModal.validateFields((err, values) => {
                    if(!err) {
                        if(this.couponListSelected.length == 0) {
                            this.$message.error('请选择优惠券');
                            return
                        }
                        values.couponId = this.couponListSelected[0].id;
                        values.couponName = this.couponListSelected[0].name;
                        const RemarkCategory = {
                            'Compensate':'客诉',
                            'PublicRelation':'公关',
                            'Activity':'活动',
                            'EmployeeBenefits':'员工福利',
                        }
                        values.remarkCategoryName = RemarkCategory[values.remarkCategoryCode]
                        if(this.type == 'single') {
                            this.loading = true;
                            this.$api.changeCode.singleOfferCoupon({
                                body: {
                                    ...values,
                                }
                            })
                            .then(res => {
                                this.$message.success("操作成功");
                                this.loading = false;
                                this.visible = false;
                                this.formModal.resetFields();
                                this.couponListSelected = [];
                                this.getList();
                            })
                            .catch(err => {
                                this.loading = false
                            })
                        }else {
                            if(this.fileList.length == 0) {
                                this.$message.error('请上传导入表格');
                                return
                            }
                            for (let key in values) {
                                this.formData.append(key, values[key])
                            }
                            this.loading = true;
                            this.$api.changeCode.batchOfferCoupon({
                                body: this.formData,
                                header: {
                                    'Content-Type': 'multipart/form-data'
                                },
                            })
                            .then(res => {
                                this.$message.success("操作成功");
                                this.loading = false;
                                this.visible = false;
                                this.formModal.resetFields();
                                this.couponListSelected = [];
                                this.fileList = [];
                                this.formData = undefined;
                                this.getList();
                            })
                            .catch(err => {
                                this.loading = false;
                                this.formData = undefined;
                                for (let key in values) {
                                    delete this.formData[key]
                                }
                            })
                        }
                    }
                });
            },
            // 获取新优惠券列表
            getNewCoupons(suitType, type) {
                this.$api.changeCode.queryNewCoupon().then(res => {
                    res.forEach((item, index) => {
                        item.goodsType = 2;
                        item.value = item.id;
                    });
                    this.newCouponsList = res
                });
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.formModal = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
            this.getNewCoupons();
        }
    };
</script>
<style lang="scss">
    .container {
        background: #fff;
    }
</style>